import { CurrencyPipe } from "@angular/common";
import { Directive, ElementRef, HostListener, OnInit } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[ofCurrencyInput]",
  providers: [CurrencyPipe],
})
export class CurrencyInputDirective implements OnInit {
  private _el: HTMLInputElement;

  private _focused = false;

  constructor(
    private _elementRef: ElementRef,
    private _currencyPipe: CurrencyPipe,
    private _elementFormControl: NgControl
  ) {
    this._el = this._elementRef.nativeElement;
  }

  ngOnInit(): void {
    this._writeValue(this._el.value);
  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value): void {
    this._focused = false;
    this._writeValue(value);
    value = Number.parseFloat(value.replace(/[^0-9.]/g, ""));
    this._elementFormControl.control.setValue(isNaN(value) ? null : value);
  }

  @HostListener("focus", ["$event.target.value"])
  onFocus(value): void {
    this._focused = true;
    this._writeValue(value);
  }

  @HostListener("keyup", ["$event.target.value"])
  onkeyup(value): void {
    this._el.value = value.replace(/[^0-9.]/g, "").trim();
    // this._writeValue( value );
  }

  @HostListener("ngModelChange", ["$event"])
  onModelChange(e): void {
    if (this._focused) {
      return;
    }
    this._writeValue(e);
  }

  private _writeValue(value: any): void {
    if (value == null) {
      this._el.value = null;
    } else if (typeof value === "number") {
      this._el.value = this._currencyPipe.transform(value, "", "");
    } else {
      const t = value.replace(/[^0-9.]/g, "").trim();
      this._el.value =
        t.length === 0 ? "" : this._currencyPipe.transform(+t, "", "");
    }
  }
}
